import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NavControls() {
  const navigate = useNavigate();
  return (
    <div className="nav-controls">
      <button className="nav-btn" onClick={() => navigate(-1)} title="Back">&#8249;</button>
      <button className="nav-btn" onClick={() => navigate(1)} title="Forward">&#8250;</button>
    </div>
  );
}